module.exports = __webpack_public_path__ + "img/welcome2.7eed0208.png";